import React from 'react';
import { GripVertical } from 'lucide-react';
import { COLOR_SETS } from '../lib/constants.js';
import { entryHours, fmtDur } from '../lib/time.js';

export function ProjectSuggestions({
  projects,
  projectLastUsed = {},
  weekEntries,
}) {
  const hoursByProject = weekEntries.reduce((acc, entry) => {
    acc[entry.projectId] = (acc[entry.projectId] || 0) + entryHours(entry);
    return acc;
  }, {});
  // `projectLastUsed` (from /bootstrap) is a { projectId: "YYYY-MM-DDTHH:MM" }
  // map of the caller's most recent use of each project — lexically sortable,
  // so most-recently-used floats to the top and ties fall back to name.
  const sortedProjects = [...projects]
    .sort((a, b) => {
      const lastA = projectLastUsed[a.id] || '';
      const lastB = projectLastUsed[b.id] || '';
      if (lastA !== lastB) return lastB.localeCompare(lastA);
      return a.name.localeCompare(b.name);
    })
    .slice(0, 10);

  return (
    <aside className="project-suggestions">
      <div className="suggestions-title">Recent projects</div>
      <div className="suggestions-list">
        {sortedProjects.map((project) => {
          const color = COLOR_SETS[project.color] || COLOR_SETS.teal;
          const hasBudgetStats =
            Number.isFinite(project.budgetMD) &&
            Number.isFinite(project.spentMD);
          const burn = hasBudgetStats
            ? (project.spentMD / Math.max(1, project.budgetMD)) * 100
            : 0;
          return (
            <div
              key={project.id}
              draggable
              className="project-suggestion"
              onDragStart={(event) => {
                event.dataTransfer.effectAllowed = 'copy';
                event.dataTransfer.setData(
                  'application/project-id',
                  project.id,
                );
                event.dataTransfer.setData('text/plain', project.id);
              }}
            >
              <div className="suggestion-head">
                <GripVertical size={14} />
                <span className="dot" style={{ background: color.bg }} />
                <span
                  className="mini-code"
                  style={{ background: color.soft, color: color.text }}
                >
                  {project.code}
                </span>
                <strong>{project.name}</strong>
              </div>
              <div className="suggestion-meta">
                <span>
                  My week: <b>{fmtDur(hoursByProject[project.id] || 0)}</b>
                </span>
                {hasBudgetStats && <span>{burn.toFixed(0)}%</span>}
              </div>
              {hasBudgetStats && (
                <>
                  <div className="suggestion-bar">
                    <span
                      style={{
                        width: `${Math.min(100, burn)}%`,
                        background: burn > 90 ? 'var(--warn)' : color.bg,
                      }}
                    />
                  </div>
                  <small>
                    {project.budgetMD} MD budget ·{' '}
                    {(project.budgetMD - project.spentMD).toFixed(1)} MD left
                  </small>
                </>
              )}
            </div>
          );
        })}
      </div>
    </aside>
  );
}
